export const CallingApp = 'GreenYourBills Admin Panel';